import store from '@/store';
import { Mutations } from '@/ts/store/Constants';

const saveScroll = (elementId: string, mutation: string) => {
    const element = document.getElementById(elementId);
    const page     = elementId.split('-').pop();

    if (element) {
        store.commit(mutation, { page, scrollPosition: element.scrollTop });
        return true;
    } else {
        return true;
    }
};

const setScroll = (elementId: string, getter: string) => {
    const element = document.getElementById(elementId);

    if (element) {
        const page = elementId.split('-').pop();
        element.scrollTop = store.getters['Scroll/' + getter](page);
    }
};

const resetScroll = (pageIndex: string, containerId: string, userType: string) => {
    if (userType === 'staff') {
        store.commit(Mutations.SET_STAFF_APP_PAGE_SCROLL_POSITION, {
            page: pageIndex,
            scrollPosition: 0,
        });

        setScroll(containerId, 'getStaffAppPagePosition');
    }

    // ... extendable
};

export {
    saveScroll,
    setScroll,
    resetScroll,
};
